module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("foW7p"))).then(() => parcelRequire('hEqeo'));